import React, { useState } from "react";

import * as S from "./styles";
import Logo from "../../assets/logoOrgannact.png";
import { useNavigate } from "react-router";
import { doLogin, requestPassword } from "../../api/auth";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { login } from "../../redux/slices/authSlice";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { Label, Input, Button } from "../main-styles";

function SignIn() {
  window.document.title = "Organnact - Login";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState({
    username: "",
    password: "",
    authenticating: false,
    recovery_username: "",
    request_success: false,
    show_recovery: false,
  });
  const {
    username,
    password,
    authenticating,
    recovery_username,
    request_success,
    show_recovery,
  } = state;

  async function handleLogin() {
    if (authenticating) return;
    if (!username || !password) {
      toast.error("Usuário e senha são obrigatórios", {
        duration: 3000,
        position: "bottom-center",
      });
      return;
    }

    try {
      setState((s) => ({ ...s, authenticating: true }));
      const response = await doLogin(username, password);
      console.log("response", response);
      const { token, refreshToken, user } = response;
      const admin = user.roles.includes("admin");
      dispatch(
        login({
          user,
          token,
          refreshToken,
          admin,
          roles: user.roles || [],
        })
      );
      setState((s) => ({ ...s, authenticating: false }));
      if (admin) {
        navigate("/admin/dashboard");
      }
    } catch (error) {
      console.log("Login failed:", error);
      toast.error("Usuário ou senha inválidos", {
        duration: 3000,
        position: "bottom-center",
      });
      setState((s) => ({ ...s, authenticating: false }));
      return;
    }
  }

  function updateState(field, value) {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  function handleKeyDown(e) {
    if (e.key === "Enter") {
      handleLogin();
    }
  }

  return (
    <S.Container>
      <S.LoginBox>
        <img src={Logo} alt="Organnact Logo" />
        <S.FormLabel>Usuário</S.FormLabel>
        <S.FormInput
          id="username"
          type="text"
          placeholder="Digite seu usuário"
          autoComplete="username"
          autoFocus
          value={username}
          onChange={(e) =>
            setState({ ...state, username: e.target.value.replace("@", "") })
          }
          onKeyDown={handleKeyDown}
        />
        <S.FormLabel>Senha</S.FormLabel>
        <S.FormInput
          type="password"
          placeholder="Digite sua senha"
          value={password}
          onChange={(e) => setState({ ...state, password: e.target.value })}
          onKeyDown={handleKeyDown}
        />
        <S.LoginButton onClick={handleLogin}>
          {authenticating ? <Spinner size={"sm"} /> : "Entrar"}
        </S.LoginButton>
        <S.Divider />
        <S.ForgotLink onClick={() => updateState("show_recovery", true)}>
          Esqueci minha senha
        </S.ForgotLink>
      </S.LoginBox>
      <Modal
        isOpen={show_recovery}
        toggle={() => {
          updateState("show_recovery", false);
          updateState("request_success", false);
          updateState("recovery_username", "");
        }}
      >
        {request_success ? (
          <div style={{ color: "green", padding: 20, textAlign: "center" }}>
            Se houver uma conta com este usuário, você receberá um link de
            recuperação de senha no e-mail cadastrado em breve.
          </div>
        ) : (
          <>
            <ModalHeader>Recuperação de senha</ModalHeader>
            <ModalBody>
              <Label>Digite seu usuário</Label>
              <Input
                type="text"
                value={recovery_username}
                onChange={(e) =>
                  updateState(
                    "recovery_username",
                    e.target.value.replace("@", "")
                  )
                }
                placeholder="Digite seu usuário"
              />
              <Button
                onClick={async () => {
                  if (!recovery_username || !recovery_username.trim()) {
                    toast.error("Insira seu usuário");
                    return;
                  }
                  try {
                    setState((s) => ({ ...s, request_success: false }));
                    await requestPassword(recovery_username.trim());
                    updateState("request_success", true);
                  } catch (error) {
                    console.error("Erro ao recuperar senha:", error);
                    toast.error("Erro ao enviar instruções de recuperação");
                  }
                }}
              >
                Enviar
              </Button>
            </ModalBody>
          </>
        )}
      </Modal>
    </S.Container>
  );
}

export default SignIn;
